export default function RoundBox({ children, className }) {
  return (
    <div className={ cn('shadow-[0_4px_12px_0px_rgba(0,0,0,0.1)] px-2 py-4 rounded-md border border-[#EEEEEE] bg-white', className) }>
      { children }
    </div>
  )
}
